import React, { startTransition } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { OpenInFullOutlined } from '@mui/icons-material';
import LaunchIcon from '@mui/icons-material/Launch';
import { AB_TEST_VARIANT_A, useAbTest } from '@shape/feature-flag';
import { TextButton, useModal } from '@shape-ds/components';
import { useTranslation } from 'react-i18next';
import './ExpandButton.scss';
import { useFormContext } from 'react-hook-form';

interface ExpandButtonProps {
  expandedPageUrl: string;
  navigationState: object;
}

const ExpandButton: React.FC<ExpandButtonProps> = ({ expandedPageUrl, navigationState }) => {
  const navigate = useNavigate();
  const { enabled, variant } = useAbTest('expand-case-button');
  const { closeModal } = useModal();
  const { t } = useTranslation();
  const formMethods = useFormContext();

  if (!enabled) {
    return (
      <Link
        className="icon-button expand-button is-flex is-align-items-center"
        to={expandedPageUrl}
        target="_blank"
      >
        <LaunchIcon />
      </Link>
    );
  }
  const onClickNavigate = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();
    startTransition(() => {
      const dirtyFields = formMethods?.formState.dirtyFields;
      const lastEditedField = dirtyFields ? Object.keys(dirtyFields).pop() : null;
      navigate(expandedPageUrl, {
        state: { ...navigationState, selectedItem: formMethods?.getValues(), lastEditedField },
      });
    });
    closeModal();
  };

  return variant === AB_TEST_VARIANT_A ? (
    <IconButton className="expand-button icon-button" onClick={onClickNavigate}>
      <OpenInFullOutlined />
    </IconButton>
  ) : (
    <TextButton
      className="expand-button text-button"
      startIcon={<OpenInFullOutlined />}
      onClick={onClickNavigate}
    >
      {t('case:buttons.expandCase')}
    </TextButton>
  );
};

export default ExpandButton;
